export const quillFormats = [
    'header',
    // 'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'indent',
    'link',
    'align',
    'direction',
    'color',
    'background'
];

export const quillModule = {
    toolbar: {
        container: '#toolbar',
        handlers: {}
    },
    clipboard: {
        matchVisual: false
    }
};
